<script setup>
import { useIntervalFn } from '@vueuse/core'
import ErrorMessage from '~/components/App/ErrorMessage.vue'
const route = useRoute()

const disruptions = ref(null)

const getStop = async () => await $fetch(`/api/stops/${route.params.id}`)

const getStopDisruptions = async () =>
  await $fetch(
    `/api/disruptions/stop/${route.params.id}?text=true&fake=false&lang=fr`,
  )

getStopDisruptions().then((response) => {
  disruptions.value = response
})

const { data: stop, status } = useLazyAsyncData(
  `stop-${route.params.id}`,
  getStop,
)
const pending = computed(() => status.value === 'pending')

useIntervalFn(async () => {
  if (!pending.value) {
    stop.value = await getStop()
  }
}, 10000)

const filteredDepartures = computed(() => {
  const departures = stop.value?.departures || []
  // const departures = [
  //   {
  //     __typename: 'Departure',
  //     destination: '1',
  //     th: '2024-08-06T11:29:00+02:00',
  //     rt: '2024-08-06T12:35:46+02:00',
  //     cancelled: false,
  //     name: '208',
  //     colour: '2d358c'
  //   },
  //   {
  //     __typename: 'Departure',
  //     destination: '2',
  //     th: '2024-08-06T11:29:00+02:00',
  //     rt: '2024-08-06T12:36:46+02:00',
  //     cancelled: false,
  //     name: '208',
  //     colour: '2d358c'
  //   },
  //   {
  //     __typename: 'Departure',
  //     destination: '3',
  //     th: '2024-08-06T11:29:00+02:00',
  //     rt: '2024-08-06T12:59:46+02:00',
  //     cancelled: false,
  //     name: '208',
  //     colour: '2d358c'
  //   },
  //   {
  //     __typename: 'Departure',
  //     destination: '4',
  //     th: '2024-08-06T11:29:00+02:00',
  //     rt: '2024-08-06T13:10:46+02:00',
  //     cancelled: false,
  //     name: '208',
  //     colour: '2d358c'
  //   },
  //   {
  //     __typename: 'Departure',
  //     destination: '5',
  //     th: '2024-08-06T11:29:00+02:00',
  //     rt: '2024-08-06T14:10:46+02:00',
  //     cancelled: false,
  //     name: '208',
  //     colour: '2d358c'
  //   },
  // ];
  const notCancelledDepartures = departures.filter(
    (item) => !item.cancelled && !useOutdated(item),
  )
  const lessThanAHour = notCancelledDepartures.filter(
    (item) => !useMoreThanAHour(item),
  )
  const firstMoreThanAHour = notCancelledDepartures.find((item) =>
    useMoreThanAHour(item),
  )

  return [...lessThanAHour, firstMoreThanAHour].filter((item) => !!item)
})
</script>

<template>
  <section>
    <div
      v-if="disruptions && disruptions.length > 0"
      class="flex flex-col gap-2 pb-10"
    >
      <ErrorMessage
        v-for="(disruption, i) in disruptions"
        :key="i"
        :title="disruption.title"
        :message="disruption.description"
        :color="disruption.color"
        :line="disruption.line_number"
      />
    </div>
    <Head>
      <Title>{{
        stop?.name ? `${stop?.name} – VMCV Timetable` : 'VMCV Timetable'
      }}</Title>
    </Head>
    <AppArticleHeader :title="stop?.name" :pending="pending">
      <div
        class="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-7"
      >
        <div>{{ stop?.name }}</div>
        <div
          v-if="stop?.platform"
          class="font-medium text-base flex items-center -mt-px"
        >
          <span>Quai: </span>
          <div
            class="ml-2 border border-vmcv-gray-darker rounded-md w-8 h-8 text-center flex items-center justify-center"
          >
            <div>{{ stop?.platform }}</div>
          </div>
        </div>
      </div>
    </AppArticleHeader>
    <section>
      <DepartureList :pending="pending" :departures="filteredDepartures" />
    </section>
  </section>
</template>
